import React, { Component } from 'react';
import { motion } from "framer-motion"
import Grid from '@material-ui/core/Grid';
import Divider from '@material-ui/core/Divider';
import Button from '@material-ui/core/Button';
import StarfieldAnimation from 'react-starfield-animation';
import LazyLoad from 'react-lazyload';
import MobileStepper from '@material-ui/core/MobileStepper';
import axios from 'axios';
import {
  BrowserView,
  MobileView,
  isMobile
} from "react-device-detect";
import './App.css';
import { CircularProgressbar } from 'react-circular-progressbar';
import 'react-circular-progressbar/dist/styles.css';
import ReactTextTransition from "react-text-transition";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { css } from 'glamor';

const multiChosing = "Cart";
const singleChosing = "Select";
const images = "Image";
const multiChosingText = ["Island"]
const multiChoiceText = ["What would you take with you to a space adventure"]
const filesBaseUrl = process.env.PUBLIC_URL + '/assets/';

const minimumChose = 5;
const diceImage = filesBaseUrl + "dice.jpeg";
const baseUrl = "https://api-dev.confirmu.com/";

const gifsLibrary = {
  1: filesBaseUrl + 'story/Start.gif',
  2: filesBaseUrl + 'story/stage-1.gif',
  3: filesBaseUrl + 'story/stage-2.gif',
  4: filesBaseUrl + 'story/stage-3.gif',
  5: filesBaseUrl + 'story/stage-5.gif',
  6: filesBaseUrl + 'story/stage-6.gif',
  7: filesBaseUrl + 'story/stage-7.gif',
  8: filesBaseUrl + 'story/stage-8.gif'
};

const gifsLibrarySen = {
  1: filesBaseUrl + 'story/Sen1.gif',
  2: filesBaseUrl + 'story/Sen2.gif',
  3: filesBaseUrl + 'story/Sen3.gif',
  4: filesBaseUrl + 'story/Sen4.gif',
  5: filesBaseUrl + 'story/Sen5.gif',
  6: filesBaseUrl + 'story/Sen6.gif',
  7: filesBaseUrl + 'story/Sen7.gif',
  8: filesBaseUrl + 'story/Sen8.gif'
}

const facebookAttachedContent = "Check it out!";
const toastConfiguration = {
  autoClose: 2000,
}
const multiChoiceCartText = "Astro needs some energy, please help him choose food for his return journey to space";
const singleChoiceText = "Which one do you like the most?";

toast.configure(toastConfiguration)

const StarfieldAnimationComponent = React.memo(function StarfieldAnimationComponent(props) {
  return (
    <StarfieldAnimation
      style={{
        position: 'absolute',
        width: '100%',
        height: '100vh'
      }}
    />
  );
});

class App extends Component {
  componentWillUnmount(){
    clearTimeout(this.startButtonAfterAnimation);
  }

  componentDidMount() {
    /* Force HTTPS protocol for all devices */
    this.forceHttps();

    /* Validate client */
    this.validate();

    /* Pre load games gifs */
    this.gifsPreLoading();

    /* Start initial animation */
    if (!this.state.started) {
      this.startButtonAfterAnimation();
    }

    /* Check if similarity test was conducted (v2) */
    this.state.similarityTestConducted && this.similarityScore();
  }

  constructor(props) {
    super(props);
    this.state = {
      accessToken: '',
      partner: '',
      externalId: '',
      validate: false,
      chose: false,
      answer: '',
      activeStep: 0,
      activeStepProp: 0,
      score: 0,
      link: '',
      started: false,
      levels: 0,
      selectedItems: [],
      showButtonStart: false,
      preview: false,
      finished: false,
      showButtonEnd: false,
      betweenStages: false,
      statistics: [],
      statisticsFound: '',
      imageAnswerSide: '',
      questions: [],
      gifOfStage: gifsLibrary[1],
      gifOfStageSub: '',
      preloadedGamesGifs: [],
      preloadedGamesGifsSen: [],
      similarityTestConducted: false,
      similarityTestConductedScore: 0,
      answers_image: [],
      answers_dice: [],
      answers_cart: [],
      answers_island: [],

      tracking_interaction_start: '',
      tracking_interaction_status: false,

      image_question_tracking_time_ms: 0,
      dice_question_tracking_time_ms: 0,
      cart_question_tracking_time_ms: 0,
      welcome_question_tracking_time_ms: 0,
      introduction_question_tracking_time_ms: 0,
      summary_question_tracking_time_ms: 0,
      island_question_tracking_time_ms: 0,

      total_questions_tracking_time_ms: 0,

      nextLevelExists: true,

      scenario_id: 0
    };

    this.validate = this.validate.bind(this);
    this.addXP = this.addXP.bind(this);
    this.swipeUpDown = this.swipeUpDown.bind(this);
    this.start = this.start.bind(this);
    this.startButtonAfterAnimation = this.startButtonAfterAnimation.bind(this);
    this.gifByStage = this.gifByStage.bind(this);
    this.getQuestions = this.getQuestions.bind(this);
    this.startGame = this.startGame.bind(this);
    this.startTrackingUserInteraction = this.startTrackingUserInteraction.bind(this);
    this.stopTrackingUserInteraction = this.stopTrackingUserInteraction.bind(this);
    this.gifsPreLoading = this.gifsPreLoading.bind(this);
    this.endGame = this.endGame.bind(this);
    this.shuffleArray = this.shuffleArray.bind(this);
    this.similarityScore = this.similarityScore.bind(this);
    this.saveAnswer = this.saveAnswer.bind(this);
    this.sendAnswers = this.sendAnswers.bind(this);
    this.singleChosingPress = this.singleChosingPress.bind(this);
    this.multiChosingPressDone = this.multiChosingPressDone.bind(this);
    this.cartTempBandaid = this.cartTempBandaid.bind(this);
    this.multiChosingPress = this.multiChosingPress.bind(this);
    this.next = this.next.bind(this);
    this.handleNext = this.handleNext.bind(this);
    this.endButtonAfterAnimation = this.endButtonAfterAnimation.bind(this);
    this.pointsObject = this.pointsObject.bind(this);
    this.notify = this.notify.bind(this);
    this.diceTextModifier = this.diceTextModifier.bind(this);
  }

  validate = () => {
    /* Validate client */
    let urlParams = new URLSearchParams(window.location.search);

    let accessToken = urlParams.get('token');
    let partner = urlParams.get('partner');
    let externalId = urlParams.get('external');
    let link = urlParams.get('share');

    // console.log('Access-Token:' + accessToken + '\nPartner:' + partner + '\nExternalId:' + externalId);

    if (
      accessToken === '' || accessToken === null || accessToken === undefined ||
      partner === '' || partner === null || partner === undefined ||
      externalId === '' || externalId === null || externalId === undefined
    ) {
      this.setState({validate: false});
    } else {
       let url = 'https://api-dev.confirmu.com/api/getPartnerMetadata/';

       let headers = {
         'Content-Type' : 'application/json',
         'Access-Token': accessToken,
         'Partner' : partner,
         'Access-Control-Allow-Origin': '*'
       }

       axios.post(url, {}, { headers: headers }).then((response) => {
         let result = response.data.result;
         // console.log(result);
         if (result === true) {
           this.setState({
             validate: true,
             accessToken: accessToken,
             partner: partner,
             externalId: externalId,
           }, () => {
             this.getQuestions();

             if (link !== '' && link !== undefined && link !== null) {
               this.setState({link: link});
             }
           });
         } else {
           this.setState({validate: false});
         }
       }).catch((err) => {
         this.setState({validate: false});
       });
    }
  }

  startTrackingUserInteraction = () => {
    if (!this.state.tracking_interaction_start) {
      this.setState({
        tracking_interaction_start: new Date().getTime(),
        tracking_interaction_status: true
      });
    }
  }

  stopTrackingUserInteraction = (questionType) => {
    let currentMillisecondsPassed = new Date().getTime() - this.state.tracking_interaction_start;

    if (questionType === "Image") {
      this.setState({
        image_question_tracking_time_ms: this.state.image_question_tracking_time_ms + currentMillisecondsPassed,
        tracking_interaction_start: '',
        tracking_interaction_status: false,
        total_questions_tracking_time_ms: this.state.total_questions_tracking_time_ms + currentMillisecondsPassed
      });
    } else if (questionType === "Cart") {
      this.setState({
        cart_question_tracking_time_ms: this.state.cart_question_tracking_time_ms + currentMillisecondsPassed,
        tracking_interaction_start: '',
        tracking_interaction_status: false,
        total_questions_tracking_time_ms: this.state.total_questions_tracking_time_ms + currentMillisecondsPassed
      });
    } else if (questionType === "Select") {
      this.setState({
        dice_question_tracking_time_ms: this.state.dice_question_tracking_time_ms + currentMillisecondsPassed,
        tracking_interaction_start: '',
        tracking_interaction_status: false,
        total_questions_tracking_time_ms: this.state.total_questions_tracking_time_ms + currentMillisecondsPassed
      });
    } else if (questionType === "Island") {
      this.setState({
        island_question_tracking_time_ms: this.state.island_question_tracking_time_ms + currentMillisecondsPassed,
        tracking_interaction_start: '',
        tracking_interaction_status: false,
        total_questions_tracking_time_ms: this.state.total_questions_tracking_time_ms + currentMillisecondsPassed
      });
    } else {
      if (questionType === "welcome") {
        this.setState({
          welcome_question_tracking_time_ms: this.state.welcome_question_tracking_time_ms + currentMillisecondsPassed,
          tracking_interaction_start: '',
          tracking_interaction_status: false,
          total_questions_tracking_time_ms: this.state.total_questions_tracking_time_ms + currentMillisecondsPassed
        });
      } else if (questionType === "introduction") {
        this.setState({
          introduction_question_tracking_time_ms: this.state.introduction_question_tracking_time_ms + currentMillisecondsPassed,
          tracking_interaction_start: '',
          tracking_interaction_status: false,
          total_questions_tracking_time_ms: this.state.total_questions_tracking_time_ms + currentMillisecondsPassed
        });
      } else if (questionType === "summary") {
        this.setState({
          summary_question_tracking_time_ms: this.state.summary_question_tracking_time_ms + currentMillisecondsPassed,
          tracking_interaction_start: '',
          tracking_interaction_status: false,
          total_questions_tracking_time_ms: this.state.total_questions_tracking_time_ms + currentMillisecondsPassed
        });
      } else {
        console.log("error");
      }
    }
    // console.log('t_image:' + this.state.image_question_tracking_time_ms + '\nt_dice:' + this.state.dice_question_tracking_time_ms + '\nt_cart:' + this.state.cart_question_tracking_time_ms + '\nt_island:' + this.state.island_question_tracking_time_ms);


  }

 /**
 * Preload game gifs
 */
  gifsPreLoading = () => {
    let gifs = [];
    let gifsSen = [];

    Object.values(gifsLibrary).forEach((gif) => {
      gifs.push(<img src={gif} style={{maxHeight: '30vh', width: 'auto', bottom: 0}} alt="" />);
    });

    if (isMobile) {
      Object.values(gifsLibrarySen).forEach((gif) => {
        gifsSen.push(<img src={gif} style={{maxHeight: '10vh', width: 'auto', bottom: 0}} alt="" />);
      });
    } else {
      Object.values(gifsLibrarySen).forEach((gif) => {
        gifsSen.push(<img src={gif} style={{maxHeight: '15vh', width: 'auto', bottom: 0}} alt="" />);
      });
    }
    this.setState({preloadedGamesGifs: gifs, preloadedGamesGifsSen: gifsSen});
  }

  /**
  * End game and update state trigger
  */
  endGame = () => {
    this.sendAnswers();
    this.setState({finished: true});
    this.endButtonAfterAnimation();
  }

  /**
  * shuffleArray - just for test
  * #TODO - remove this function on production
  */
  shuffleArray = (questions) => {
    let imagesQuestion = false;
    let multiSelectQuestion = false;
    let a = questions;
    var j, x, i;
    for (i = a.length - 1; i > 0; i--) {
        j = Math.floor(Math.random() * (i + 1));
        x = a[i];
        a[i] = a[j];
        a[j] = x;
    }

    let array = [];
    a.forEach((object) => {
      if (object.QuestionType !== "Decision") {
        if (object.QuestionType === "Image" && !imagesQuestion && object.QuestionId !== 'Decision2') {
          array.push(object);
          imagesQuestion = true;
        }

        if (object.QuestionType === "Cart" && !multiSelectQuestion && object.QuestionId !== 'Decision2') {
          array.push(object);
          multiSelectQuestion = true;
        }

        if (object.QuestionType !== "Image" && object.QuestionType !== "Cart" && object.QuestionId !== 'Decision2') {
          array.push(object);
        }
      }
    });


    return array;
  }

  /**
  * Get the correct game-gif for the correct stage
  */
  gifByStage = () => {
    this.setState({gifOfStage: this.state.preloadedGamesGifs[this.state.activeStep + 1]})
  }

  /**
  * Create similarity score
  */
  similarityScore = () => {
    let similarityScore = Math.floor(Math.random() * 34) + 66;
    this.setState({similarityTestConductedScore: similarityScore});
  }

  /**
  * Get all questions from the server
  */
  getQuestions = () => {
     let url = 'https://api-dev.confirmu.com/api/schuffle/';

     let headers = {
       'Content-Type' : 'application/x-www-form-urlencoded',
       'Access-Token': this.state.accessToken,
       'Partner' : this.state.partner,
       'Access-Control-Allow-Origin': '*'
     }


     axios.post(url, {}, { headers: headers }).then((response) => {
       // console.log(response);
       let questionsFromResponse = response.data.Questions;
       let questionsFromResponseWithPoints = [];
       questionsFromResponse.forEach((question) => {
         let question_ = question;
         question_['points'] = Math.floor(Math.random() * 45) + 15;
         question_['lu'] = Math.floor(Math.random() * 50) + 20;
         questionsFromResponseWithPoints.push(question_);
       })
       console.log("questions:");
       console.log(questionsFromResponseWithPoints);
       console.log("Levels:" + questionsFromResponseWithPoints.length);
       this.setState({levels: questionsFromResponseWithPoints.length, questions: questionsFromResponseWithPoints, scenario_id: response.data.scenario_id});

       // let questions_final = this.shuffleArray(questionsFromResponse);

       // if (questions_final.length >= 5) {
       //   this.setState({questions: questions_final});
       // }
     }).catch((err) => {
       console.log(err);
       this.setState({validate: false});
     });
  }


  saveAnswer = (externalAnswer) => {
    let question = this.state.questions[this.state.activeStep];
    let questionType = question.QuestionType;
    let questionId = question.QuestionId;

    this.stopTrackingUserInteraction(questionType);

    let const_image = "Image";
    let const_select = "Select";
    let const_cart = "Cart";
    let const_island = "Island";

    if (questionType === const_image) {
      let answers_image = this.state.answers_image;
      if (externalAnswer === "right") {
        // 1
        answers_image.push({"QuestionId":questionId,"QuestionType":"Image","QuestionAnswer":1})
        this.setState({answers_image: answers_image});
      } else if (externalAnswer === "left") {
        // 0
        answers_image.push({"QuestionId":questionId,"QuestionType":"Image","QuestionAnswer":0})
        this.setState({answers_image: answers_image});
      } else {
        console.log("error");
        this.setState({validate: false});
      }
    } else if (questionType === const_select) {
      let answers_dice = this.state.answers_dice;

      answers_dice.push({"QuestionId":questionId,"QuestionType":"Select","QuestionAnswer":externalAnswer});

      this.setState({answers_dice: answers_dice});
    } else if (questionType === const_cart) {
      if (externalAnswer.length >= 5) {
        let answers_cart = this.state.answers_cart;
        externalAnswer.forEach((index) => {
          answers_cart.push({"QuestionId":questionId,"QuestionType":"Cart","QuestionAnswer":index});
        })

        this.setState({answers_cart: answers_cart});
      } else {
        console.log("error");
        this.setState({validate: false});
      }
    } else if (questionType === const_island) {
      if (externalAnswer.length >= 5) {
        let answers_island = this.state.answers_island;
        externalAnswer.forEach((index) => {
          answers_island.push({"QuestionId":questionId,"QuestionType":"Island","QuestionAnswer":index});
        })

        this.setState({answers_cart: answers_island});
      } else {
        console.log("error");
        this.setState({validate: false});
      }
    } else {
      console.log("error");
      this.setState({validate: false});
    }

    // console.log('cart:' + this.state.answers_cart);
    // console.log('dice:' + this.state.answers_dice);
    // console.log('image:' + this.state.answers_image);
    // console.log('island:' + this.state.answers_island);
  }

  sendAnswers = () => {
    let url = 'https://api-dev.confirmu.com/api/calculatePsychologyScore/';

    let headers = {
      'Content-Type' : 'application/json',
      'Access-Token': this.state.accessToken,
      'Partner' : this.state.partner,
      'ExternalId': this.state.externalId,
      'ScenarioId': this.state.scenario_id,
      'Access-Control-Allow-Origin': '*'
    }

    let body = {
      "Answers":{
        "image": this.state.answers_image,
        "dice": this.state.answers_dice,
        "cart": this.state.answers_cart
      },
      "spentTime":{
        "welcome":{"spentTime":this.state.welcome_question_tracking_time_ms},
        "introduction":{"spentTime":this.state.introduction_question_tracking_time_ms},
        "image":{"spentTime":this.state.image_question_tracking_time_ms},
        "cart":{"spentTime":this.state.cart_question_tracking_time_ms},
        "dice":{"spentTime":this.state.dice_question_tracking_time_ms},
        "summary":{"spentTime":this.state.summary_question_tracking_time_ms},
        "totalTime":this.state.total_questions_tracking_time_ms,
        "timeUnit":"ms"
      }
    }
    // console.log("----------------------------------------");
    // console.log("----------------------------------------");
    // console.log("----------------------------------------");
    // console.log("----------------------------------------");
    //
    // console.log("Body:");
    // console.log("----------------------------------------");
    // console.log(body);
    // console.log("----------------------------------------");

    axios.post(url, body, { headers: headers }).then((response) => {
      // console.log("Answers sent:");
      // console.log("----------------------------------------");
      // console.log(response);
      // console.log("----------------------------------------");
    }).catch((err) => {
      console.log(err);
    });
  }

  /**
   * Generate the main character
   *
   * @param device; get device type (mobile | desktop)
   */
  character = (device) => {
    this.startTrackingUserInteraction();
    return (
      <div>
        {this.state.gifOfStage}
      </div>
    );
  }

  /**
   * Generate the sub character
   *
   * @param device; get device type (mobile | desktop)
   */
  subCharacter = (device) => {
    this.startTrackingUserInteraction();
    return (
      <div>
        {this.state.gifOfStageSub}
      </div>
    );
  }

  /**
   * Add `experience points` to the user
   *
   * @param points; amount of `experience points` to add to the user
   */
  addXP = (points) => {
    this.setState({score: this.state.score + points});
  }

  /**
   * Swipe up or down trigger (framer motion)
   *
   * @param event; event (framer motion)
   * @param info; info (framer motion)
   * @param side; the side of the image (in a two images type of question)
   */
  swipeUpDown = (event, info, side) => {
    if (!this.state.chose) {
      if (info.point.y >= 20 || info.point.y <= -20) {
        this.setState({
          answer: side,
          chose: true,
          imageAnswerSide: (side === 'right') ? 'choice 1.png' : 'choice 2.png'
        }, () => {
          this.addXP(this.state.questions[this.state.activeStep].points)
          this.next()
          this.saveAnswer(side);
        })
      }
    }
  }


  /**
   * Generate images for a two images type of questions
   *
   * @param img; the image URL (asset's path)
   * @param side; the side of the image (left | right)
   * @param device; get device type (mobile | desktop)
   */
  image = (img, side, device) => {
    if (device === "mobile") {
      return (
        <motion.div
            initial={{ scale: 0 }}
            animate={{ rotate: 360, scale: 1 }}
            transition={{
              type: "spring",
              stiffness: 260,
              damping: 20
            }}
            whileHover={{ scale: 0.6 }}
            whileTap={{ scale: 1.3 }}
            drag="y"
            onDrag={
              (event, info) => this.swipeUpDown(event, info, side)
            }
            exit={{ x: -50 }}
          >
          <img src={img} style={{width: '150px', height: '150px', borderRadius: '15%'}} alt=""/>

        </motion.div>
      );
    } else {
      return (
        <motion.div
            initial={{ scale: 0 }}
            animate={{ rotate: 360, scale: 1 }}
            transition={{
              type: "spring",
              stiffness: 260,
              damping: 20
            }}
            whileHover={{ scale: 1.1 }}
            whileTap={{ scale: 0.9 }}
            drag="y"
            onDrag={
              (event, info) => this.swipeUpDown(event, info, side)
            }
          >
          <img src={img} style={{width: '200px', height: '200px', borderRadius: '15%'}} alt=""/>

        </motion.div>
      );
    }
  }

  /**
   * Generate an image for a (question with the type of) singleChosing
   *
   * @param img; the image URL (asset's path)
   * @param device; get device type (mobile | desktop)
   */
  singleChosingImage = (img, device) => {
    if (device === "mobile") {
      return (
        <motion.div
            initial={{ scale: 0 }}
            animate={{ rotate: 360, scale: 1 }}
            transition={{
              type: "spring",
              stiffness: 260,
              damping: 20
            }}
            exit={{ x: -50 }}
          >
          <LazyLoad><img src={img} style={{width: '50%', height: 'auto', borderRadius: '15%'}} alt="" /></LazyLoad>

        </motion.div>
      );
    } else {
      return (
        <motion.div
            initial={{ scale: 0 }}
            animate={{ rotate: 360, scale: 1 }}
            transition={{
              type: "spring",
              stiffness: 260,
              damping: 20
            }}
            whileHover={{ scale: 1.1 }}
          >
            <LazyLoad><img src={img} style={{width: '20%', height: 'auto', borderRadius: '15%'}} alt="" /></LazyLoad>
        </motion.div>
      );
    }
  }

  /**
   * Generate button(s) for a (question with the type of) singleChosing
   *
   * @param options; buttons' texts
   */
  singleChosingButtons = (options) => {
    return options.map((index, i) => {
      return (
        <Button style={{
          backgroundColor: '#F7F7F7',
          color: '#1D133B',
          fontWeight: 'bold',
          borderRadius: '45px',
          marginLeft: '1%',
          border: '1px solid white'
        }}
        key={i}
        onClick={(e) => this.singleChosingPress(index.value)}
        >
        <span className="singleChosingButtonText" style={{fontSize: '1.2em'}}>
          {index.value}
        </span>
        </Button>
      );
    });
  }

  /**
   * Trigget for button(s) in a singleChosing question
   *
   * @param answer; the index (text) of the button
   */
  singleChosingPress = (answer) => {
    this.setState({
      answer: answer,
      chose: true
    }, () => {
      this.addXP(this.state.questions[this.state.activeStep].points)
      this.next()
      this.saveAnswer(answer);
    })
  }

  /**
   * Trigget for `Done` button in a multiChosing question
   */
  multiChosingPressDone = () => {
    this.setState({
      answer: this.state.selectedItems,
      chose: true
    }, () => {
      this.addXP(this.state.questions[this.state.activeStep].points)
      this.next()
      this.saveAnswer(this.state.selectedItems);
      this.setState({selectedItems: []})
    })
  }

  startGame = () => {
    this.setState({preview: true});
    this.gifByStage();
  }

  cartTempBandaid = (index) => {
    let ctb_data = {
      'Coffee': filesBaseUrl + 'tempcart/Coffee.png',
      'Crackers': filesBaseUrl + 'tempcart/crackers.png',
      'Cheese': 'delete'
    }

    if (index.value === 'Cheese') {
      return ctb_data['Cheese'];
    } else if (index.value === 'Coffee') {
      return ctb_data['Coffee'];
    } else if (index.value === 'Crackers') {
      return ctb_data['Crackers'];
    } else {
      return false;
    }
  }

  /**
   * Generate button(s) for a (question with the type of) multiChosing
   *
   * @param options; buttons' texts
   */
  multiChosingButtons = (options, device) => {
    let not_allowed = ["Choclate fudge", "Crackers"]
    if (device === "mobile") {
      return options.map((index, i) => {
        if (!not_allowed.includes(index.value)) {
          let index_url = this.cartTempBandaid(index);
          if (index_url === false) {
            index_url = index.url;
          } else {
            if (index_url !== 'delete') {
              index_url = this.cartTempBandaid(index);
            }
          }

          if (index_url !== 'delete') {
            if (!this.state.selectedItems.includes(index_url)) {
              return (
                <Button style={{
                  backgroundColor: '#F7F7F7',
                  color: '#1D133B',
                  fontWeight: 'bold',
                  borderRadius: '65px',
                  marginLeft: '3%',
                  marginTop: '3%',
                  border: '1px solid white'
                }}
                key={i}
                onClick={(e) => this.multiChosingPress(index_url)}
                >
                <span style={{fontSize: '1em'}}>
                  <LazyLoad><img src={index_url} style={{width: '30px'}} alt="" /></LazyLoad>
                </span>
                </Button>
              );
            } else {
              return (
                <Button style={{
                  backgroundColor: '#1D133B',
                  color: 'white',
                  fontWeight: 'bold',
                  borderRadius: '65px',
                  marginLeft: '3%',
                  marginTop: '3%',
                  border: '1px solid white'
                }}
                key={i}
                onClick={(e) => this.multiChosingPress(index_url)}
                >
                <span style={{fontSize: '1em'}}>
                  <LazyLoad><img src={index_url} style={{width: '30px'}} alt="" /></LazyLoad>
                </span>
                </Button>
              );
            }
          } else {
            return null;
          }
        }
      });
    } else {
      return options.map((index, i) => {
        if (!not_allowed.includes(index.value)) {
          let index_url = this.cartTempBandaid(index);
          if (index_url === false) {
            index_url = index.url;
          } else {
            if (index_url !== 'delete') {
              index_url = this.cartTempBandaid(index);
            }
          }

          if (index_url !== 'delete') {
            if (!this.state.selectedItems.includes(index_url)) {
              return (
                <Button style={{
                  backgroundColor: '#F7F7F7',
                  color: '#1D133B',
                  fontWeight: 'bold',
                  borderRadius: '45px',
                  marginLeft: '3%',
                  marginTop: '3%',
                  border: '1px solid white'
                }}
                key={i}
                onClick={(e) => this.multiChosingPress(index_url)}
                >
                <span style={{fontSize: '2em'}}>
                  <LazyLoad><img src={index_url} style={{width: '40px'}} alt="" /></LazyLoad>
                </span>
                </Button>
              );
            } else {
              return (
                <Button style={{
                  backgroundColor: '#1D133B',
                  color: 'white',
                  fontWeight: 'bold',
                  borderRadius: '45px',
                  marginLeft: '3%',
                  marginTop: '3%',
                  border: '1px solid white'
                }}
                key={i}
                onClick={(e) => this.multiChosingPress(index_url)}
                >
                <span style={{fontSize: '2em'}}>
                  <LazyLoad><img src={index_url} style={{width: '40px'}} alt="" /></LazyLoad>
                </span>
                </Button>
              );
            }
          } else {
            return null;
          }
        }
      });
    }
  }

  /**
   * Generate button(s) for a (question with the type of) multiChosing with text instead of images
   *
   * @param options; buttons' texts
   */
  multiChosingTextButtons = (options, device) => {
    let not_allowed = ["Wine"];
    if (device === "mobile") {
      return options.map((index, i) => {
        if (!not_allowed.includes(index.value)) {
          if (!this.state.selectedItems.includes(index.value)) {
            return (
              <Button style={{
                backgroundColor: '#F7F7F7',
                color: '#1D133B',
                fontWeight: 'bold',
                borderRadius: '65px',
                marginLeft: '3%',
                marginTop: '3%',
                border: '1px solid white'
              }}
              key={i}
              onClick={(e) => this.multiChosingPress(index.value)}
              >
              <span style={{fontSize: '0.5em'}}>
                {index.value}
              </span>
              </Button>
            );
          } else {
            return (
              <Button style={{
                backgroundColor: '#1D133B',
                color: 'white',
                fontWeight: 'bold',
                borderRadius: '65px',
                marginLeft: '3%',
                marginTop: '3%',
                border: '1px solid white'
              }}
              key={i}
              onClick={(e) => this.multiChosingPress(index.value)}
              >
              <span style={{fontSize: '0.5em'}}>
                {index.value}
              </span>
              </Button>
            );
          }
        }
      });
    } else {
      return options.map((index, i) => {
        if (!not_allowed.includes(index.value)) {
          if (!this.state.selectedItems.includes(index.value)) {
            return (
              <Button style={{
                backgroundColor: '#F7F7F7',
                color: '#1D133B',
                fontWeight: 'bold',
                borderRadius: '45px',
                marginLeft: '3%',
                marginTop: '3%',
                border: '1px solid white'
              }}
              key={i}
              onClick={(e) => this.multiChosingPress(index.value)}
              >
              <span style={{fontSize: '1em'}}>
                {index.value}
              </span>
              </Button>
            );
          } else {
            return (
              <Button style={{
                backgroundColor: '#1D133B',
                color: 'white',
                fontWeight: 'bold',
                borderRadius: '45px',
                marginLeft: '3%',
                marginTop: '3%',
                border: '1px solid white'
              }}
              key={i}
              onClick={(e) => this.multiChosingPress(index.value)}
              >
              <span style={{fontSize: '1em'}}>
                {index.value}
              </span>
              </Button>
            );
          }
        }
      });
    }
  }

  /**
   * Trigger for button in a multiChosing question
   *
   * @param options; button's texts
   */
  multiChosingPress = (answer) => {
    // console.log("answer:" + answer);
    if (!this.state.selectedItems.includes(answer)) {
      if (this.state.selectedItems.length < minimumChose) {
        let selectedItems = this.state.selectedItems;
        selectedItems.push(answer);
        this.setState({selectedItems: selectedItems});
      }
    } else {
      let array = this.state.selectedItems;
      let index = array.indexOf(answer);
      if (index !== -1) array.splice(index, 1);
      this.setState({selectedItems: array});
    }
  }

  /**
   * Start the game trigger
   */
  start = () => {
    this.setState({
      started: true
    });
  }

  /**
   * next question trigger
   */
  next = () => {
    this.setState({betweenStages: true, gifOfStageSub: this.state.preloadedGamesGifsSen[this.state.activeStep]}); // interaction
    if (this.state.questions[this.state.activeStep + 1] === undefined) {
      this.setState({nextLevelExists: false, activeStepProp: this.state.activeStepProp + 1});
    } else {
      this.setState({activeStep: this.state.activeStep + 1, activeStepProp: this.state.activeStepProp + 1});
    }

    console.log(this.state.questions[this.state.activeStep]);

    setTimeout(()=>{
      this.setState({
        betweenStages: false, // reset interaction
        gifOfStage: '', // reset interaction
        chose: false
      }, () => {
        this.gifByStage()
        // console.log('next stage:');
        // console.log(this.state.questions[this.state.activeStep]);
      });
    }, 3000);
  }

  /**
   * Handle next step in the MobileStepper
   */
  handleNext = () => {
    this.setState({activeStep: this.state.activeStep + 1});
  };

  /**
  * start start animation after 10 seconds
  */
  startButtonAfterAnimation = () => {
    setTimeout(()=>{
      this.setState({showButtonStart: true});
    }, 9000);
  }

  /**
  * start end animation after 3 seconds
  */
  endButtonAfterAnimation = () => {
    setTimeout(()=>{
      this.setState({showButtonEnd: true});
    }, 3000);
  }

  /**
   * Handle point object to each device
   */
  pointsObject = (device) => {
    // console.log(this.state.betweenStages + ' : ' + this.state.activeStep + ' : ' + this.state.levels);
    // console.log(this.state.gifOfStageSub);
    return (
      <React.Fragment>
        <LazyLoad><img src={filesBaseUrl + "Badge.png"} style={{width: device === "mobile" ? '7vh' : '8vh'}} align="center" alt="" /></LazyLoad> &nbsp;
        {`${this.state.score}`.split("").map((n, i) => (
          <ReactTextTransition
            key={i}
            text={n}
            delay={i * 100}
            className={device === "mobile" ? "pointsMobile" : "points"}
            overflow
            inline
          />
        ))} <span className={device === "mobile" ? "pointsMobile" : "points"}> XP</span>
      </React.Fragment>
    )
  }

  /**
   * Notify - future option
   */
  notify = (howManyPeopleChoseThisOption) => {
    let text = howManyPeopleChoseThisOption + '% of the people chose this option!'
    toast(text, {
      position: isMobile ? toast.POSITION.TOP_CENTER : toast.POSITION.TOP_RIGHT,
      className: css({
        color: '#1D133B',
        fontSize: '1em'
      }),
    });
  }

  /**
   * Handle text of Dice object
   */
  diceTextModifier = (question) => {
    if (question.QuestionId === "Dice1") {
      return (
        <span>{"You have only 1 bet!"} <br /> {"1 or 6 = 5,000$. What will be your bet?"}</span>
      );
    }
    if (question.QuestionId === "Dice2") {
      return (
        <span>{"You have only 2 bets!"} <br /> {"1 or 6 =  5,000$. What will be your bet?"}</span>
      );
    }
    if (question.QuestionId === "Dice3") {
      return (
        <span>{"You have only 1 bet!"} <br /> {"1 or 6 =  10,000$. What will be your bet?"}</span>
      );
    }
    if (question.QuestionId === "Dice4") {
      return (
        <span>{"You have only 1 bet!"} <br /> {"2 or 4 =  2,000$. What will be your bet?"}</span>
      );
    }
    if (question.QuestionId === "Dice5") {
      return (
        <span>{"You have only 2 bets!"} <br /> {"2 or 4 =  2,000$. What will be your bet?"}</span>
      );
    }
    if (question.QuestionId === "Dice6") {
      return (
        <span>{"You have only 3 bets!"} <br /> {"2 or 4 = 2000$. What will be your bet?"}</span>
      );
    }
  }

  /**
   * Force https for all devices
   */
  forceHttps = () => {
    try {
      if (window.location.protocol != 'https:') {
       window.location.href = 'https:' + window.location.href.substring(window.location.protocol.length);
      }
    } catch {
      console.error("Can't force HTTPS protocol");
    }
  }

  render() {
    return (
      <React.Fragment>
        {this.state.validate ? (
          <div className={this.state.started ? "App" : "AppWelcome"}>
            {!this.state.finished && (
              <StarfieldAnimationComponent />
            )}

            <MobileView>
              {this.state.finished ? (
                <React.Fragment>
                <div style={{
                  textAlign: 'center',
                  alignItems: 'center'
                }}>
                  {!this.state.showButtonEnd ? (
                    <div style={{textAlign: 'center', alignItems: 'center'}}>
                      <center>
                        <LazyLoad><img src={filesBaseUrl + 'story/fly-up.gif'} style={{height: '100vh', width: 'auto', bottom: 0}} alt="" /></LazyLoad>
                      </center>
                    </div>
                  ) : (
                    <Grid container spacing={2}>
                      <Grid item xs={12} className="header">
                        <h1 style={{color: 'white'}}>Well Done!</h1>
                      </Grid>

                      <Grid item xs={6} className="main">
                        <div>
                        <LazyLoad><img src={filesBaseUrl + 'Badge.png'} style={{height: '15vh', width: 'auto'}} alt="" /></LazyLoad><br />
                        <h1 style={{color: 'white'}}>
                          {`${this.state.score}`.split("").map((n, i) => (
                            <ReactTextTransition
                              key={i}
                              text={n}
                              delay={i * 100}
                              overflow
                              inline
                            />
                          ))} <br />
                          XP earned</h1>
                        </div>
                      </Grid>
                      <Grid item xs={6} className="main">
                        <div style={{maxWidth: '80%'}}>
                        {this.state.similarityTestConducted ? (
                          <React.Fragment>
                          <h4 style={{color: 'white'}}>Your similarity score to Itay is</h4>
                          <CircularProgressbar value={this.state.similarityTestConductedScore} text={`${this.state.similarityTestConductedScore}%`} strokeWidth={3} styles={{
                            root: {width: '15vh'},
                            path: {
                              strokeLinecap: 'butt',
                              transition: 'stroke-dashoffset 0.5s ease 0s',
                              transform: 'rotate(0.25turn)',
                              transformOrigin: 'center center',
                            },
                            trail: {
                              stroke: '#d6d6d6',
                              strokeLinecap: 'butt',
                              transform: 'rotate(0.25turn)',
                              transformOrigin: 'center center',
                            },
                            text: {
                              fontSize: '1.5em',
                            },
                            background: {
                              fill: '#3e98c7',
                            },
                          }}/>
                          <h4 style={{color: 'white'}}>You are so similar that you should consider going to a space adventure together <span role="img" aria-label="spaceship">😋</span><span role="img" aria-label="spaceship">🚀</span></h4>
                          </React.Fragment>
                        ) : (
                          <React.Fragment>
                          {this.state.link === '' ? (
                            <React.Fragment>
                              <h3 style={{color: 'white'}}>Great Job!</h3>
                              <h4 style={{color: 'white'}}>You helped Astro to go back home!</h4>
                              <LazyLoad><img src={filesBaseUrl + 'head.png'} alt="astro"  style={{height: '15vh', width: 'auto'}} /></LazyLoad>
                            </React.Fragment>
                          ) : (
                            <React.Fragment>
                            <h3 style={{color: 'white'}}>Share your score on Facebook & find out how much your friends and family are differnt from you!</h3>
                            <div className="fb-share-button" data-href={this.state.link} data-layout="button" data-size="large">
                              <a target="_blank" rel="noopener noreferrer" href={"https://www.facebook.com/sharer/sharer.php?u="+this.state.link+"&src=sdkpreparse&quote=" + facebookAttachedContent}  className="fb-xfbml-parse-ignore">
                                <LazyLoad><img src={filesBaseUrl + 'fb.png'} alt="Facebook" /></LazyLoad>
                              </a>
                            </div>
                            </React.Fragment>
                          )}

                          </React.Fragment>
                        )}
                        </div>
                      </Grid>

                      <Grid item xs={12} className="footer">
                      <br />
                        <img src={filesBaseUrl + 'story/Finish.gif'} style={{height: '20vh', width: 'auto', bottom: 0}} alt="" />
                      </Grid>
                    </Grid>
                  )}
                </div>
                </React.Fragment>
              ) : (
                <React.Fragment>
                {this.state.started ? (
                  <Grid container spacing={2}>
                    <Grid item xs={12} className="header">
                      <React.Fragment>
                        <div style={{float: 'left', marginTop: '2%', marginLeft: '2%'}}>
                          {this.pointsObject('mobile')}
                        </div>
                        <Divider style={{
                          color: 'transparent', backgroundColor: 'transparent', marginTop: '9vh'
                        }} />
                        <div>
                        <span style={{
                          color: 'white',
                          fontWeight: 'bold',
                          textAlign: 'center',
                          marginLeft: '2%'
                        }}>The spaceship is {Math.round((100 / this.state.levels) * (this.state.activeStepProp), 2)}% ready</span>

                        <MobileStepper
                          variant="progress"
                          steps={this.state.levels + 1}
                          activeStep={this.state.activeStepProp}
                          style={{
                            backgroundColor: 'transparent',
                            minWidth: '192%',
                            textAlign: 'center',
                            alignItems: 'center'
                          }}
                          position="relative"
                        />
                        </div>
                      </React.Fragment>
                    </Grid>

                    <Grid container className="main">
                    {(this.state.betweenStages && this.state.activeStep !== this.state.levels + 1) && (
                      <div>
                        {this.subCharacter('mobile')}
                      </div>
                    )}

                    {this.state.nextLevelExists && this.state.questions[this.state.activeStep].QuestionType === multiChosing && this.state.chose === false && (this.state.activeStep < this.state.levels) && (
                      <React.Fragment>
                        <Grid item xs={12} style={{maxWidth: '85%', marginBottom: '7%'}}>
                          <span className="title">
                            {multiChoiceCartText}
                          </span> <br />
                          {this.multiChosingButtons(this.state.questions[this.state.activeStep].Options, 'mobile')}
                          <Divider style={{color: 'transparent', backgroundColor: 'transparent', marginTop: '7%'}} />
                          {this.state.selectedItems.length >= minimumChose && (

                            <center><motion.div animate={{ scale: 1.7 }} transition={{ duration: 1 }} whileHover={{ scale: 1.1 }}
                            whileTap={{ scale: 0.9 }}>
                              <Button style={{
                                backgroundColor: '#F7F7F7',
                                color: '#1D133B',
                                fontWeight: 'bold',
                                borderRadius: '45px'
                              }}
                              onClick={(e) => this.multiChosingPressDone()}>Done!</Button>
                            </motion.div></center>
                          )}
                        </Grid>
                      </React.Fragment>
                    )}

                    {(this.state.nextLevelExists && this.state.questions[this.state.activeStep].QuestionType === multiChosingText[0] || this.state.questions[this.state.activeStep].QuestionType === multiChosingText[1]) && this.state.chose === false && (this.state.activeStep < this.state.levels) && (
                      <React.Fragment>
                        <Grid item xs={12} style={{maxWidth: '85%', marginBottom: '7%'}}>
                          <span className="title">
                            {/*this.state.questions[this.state.activeStep].QuestionType === multiChosingText[0] ? multiChoiceText[0] : multiChoiceText[1]*/}
                            {this.state.questions[this.state.activeStep].QuestionText}
                          </span> <br />
                          {this.multiChosingTextButtons(this.state.questions[this.state.activeStep].Options, 'mobile')}
                          <Divider style={{color: 'transparent', backgroundColor: 'transparent', marginTop: '7%'}} />
                          {this.state.selectedItems.length >= minimumChose && (

                            <center><motion.div animate={{ scale: 1.7 }} transition={{ duration: 1 }} whileHover={{ scale: 1.1 }}
                            whileTap={{ scale: 0.9 }}>
                              <Button style={{
                                backgroundColor: '#F7F7F7',
                                color: '#1D133B',
                                fontWeight: 'bold',
                                borderRadius: '45px'
                              }}
                              onClick={(e) => this.multiChosingPressDone()}>Done!</Button>
                            </motion.div></center>
                          )}
                        </Grid>
                      </React.Fragment>
                    )}

                    {this.state.nextLevelExists && this.state.questions[this.state.activeStep].QuestionType === singleChosing && this.state.chose === false && (this.state.activeStep < this.state.levels) && (
                      <React.Fragment>
                        <Grid item xs={12} style={{maxWidth: '85%'}}>
                          <span className="title">
                            {this.diceTextModifier(this.state.questions[this.state.activeStep])}
                          </span>
                        </Grid>
                        <Grid item xs={12}>
                          <center>{this.singleChosingImage(diceImage, "mobile")}</center>
                        </Grid>
                        <Grid item xs={12}>
                          {this.singleChosingButtons(this.state.questions[this.state.activeStep].Options)}
                        </Grid>
                      </React.Fragment>
                    )}

                    {this.state.nextLevelExists && this.state.questions[this.state.activeStep].QuestionType === images && this.state.chose === false && (this.state.activeStep < this.state.levels) && (
                      <React.Fragment>
                        <center>
                          <Grid item xs={12} style={{maxWidth: '90%'}}>
                            <span className="title">
                              {singleChoiceText}
                            </span>
                          </Grid>
                        </center>

                        <Grid item xs={6}>{this.image(this.state.questions[this.state.activeStep].Images[0].url, 'left', 'mobile')}</Grid>
                        <Grid item xs={6}>{this.image(this.state.questions[this.state.activeStep].Images[1].url, 'right', 'mobile')}</Grid>
                      </React.Fragment>
                    )}

                    {this.state.finished && (
                      <Grid item xs={12}>
                        <img src={filesBaseUrl + 'story/fly-up.gif'} style={{maxHeight:'20vh', width: 'auto', bottom: '0'}} alt="" />
                      </Grid>
                    )}

                    {!this.state.nextLevelExists && (
                      <Grid item xs={12}>
                        <center><motion.div animate={{ scale: 1.7 }} transition={{ duration: 1 }} whileHover={{ scale: 1.1 }}
                        whileTap={{ scale: 0.9 }}>
                          <Button style={{
                            backgroundColor: '#F7F7F7',
                            color: '#1D133B',
                            fontWeight: 'bold',
                            borderRadius: '45px'
                          }}
                          onClick={(e) => this.endGame()}>Let's fly!</Button>
                        </motion.div></center>
                      </Grid>
                    )}


                    </Grid>


                    <Grid item xs={12} className="footer">
                    {!this.state.nextLevelExists && (
                      <img src={filesBaseUrl + 'story/stage-8.gif'} style={{maxHeight:'30vh', width: 'auto', bottom: '0'}} alt="" />
                    )}
                    {this.state.activeStep < this.state.levels && (
                      <React.Fragment>
                        {this.character("mobile")}
                      </React.Fragment>
                    )}
                    </Grid>
                  </Grid>
                ) : (
                  <Grid container spacing={2}>
                    {this.state.preview ? (
                      <React.Fragment>
                      <Grid item xs={12} className="header">
                      <center>
                        <div style={{
                          maxWidth: '85%'
                        }}>
                          <h2 style={{textAlign: 'center', color: 'white'}}>Help Astro to fix his Spaceship and return home! <span role="img" aria-label="spaceship">🚀</span></h2>
                          <h3 style={{textAlign: 'center', color: 'white'}}>Choose what best describe you, Try to set a record and help Astro rebuild his spaceship</h3>
                        </div><br />
                        <motion.div animate={{ scale: 1.7 }} transition={{ duration: 1 }} whileHover={{ scale: 1.1 }}
                        whileTap={{ scale: 0.9 }}>
                          <Button style={{
                            backgroundColor: '#F7F7F7',
                            color: '#1D133B',
                            fontWeight: 'bold',
                            borderRadius: '45px'
                          }}
                          onClick={(e) => this.start()}>START</Button>
                        </motion.div>
                      </center>
                      </Grid>

                      <Grid item xs={12} className="main">

                      </Grid>

                      <Grid item xs={12} className="footer">
                        <img src={filesBaseUrl + "story/Start.gif"} style={{maxHeight: '30vh', width: 'auto', bottom: 0}} alt="" />
                      </Grid>
                      </React.Fragment>
                    ) : (
                      <React.Fragment>
                      <Grid item xs={12} className="header">
                      {this.state.showButtonStart && (
                        <center><motion.div animate={{ rotate: 360 }} transition={{ duration: 1 }}
                         style={{
                          maxWidth: '75%'
                        }}>
                          <h1 style={{textAlign: 'center', color: 'white'}}>Oh! No! Your Spaceship crashed into an asteroid!</h1>
                        </motion.div></center>
                      )}
                      </Grid>

                      <Grid item xs={12} className="main">
                        <img src={filesBaseUrl + "story/opening-Scene.gif"} style={{maxHeight: '50vh', width: 'auto'}} alt="" />
                      </Grid>

                      <Grid item xs={12} className="footer">
                        {this.state.showButtonStart && (
                          <center><motion.div animate={{ scale: 1.7 }} transition={{ duration: 1 }} whileHover={{ scale: 1.1 }}
                          whileTap={{ scale: 0.9 }}>
                            <Button style={{
                              backgroundColor: '#F7F7F7',
                              color: '#1D133B',
                              fontWeight: 'bold',
                              borderRadius: '45px'
                            }}
                            onClick={(e) => this.startGame()}>Are you ready?</Button>
                          </motion.div></center>
                        )}
                      </Grid>
                      </React.Fragment>
                    )}

                  </Grid>
                )}
                </React.Fragment>
              )}


            </MobileView>

            <BrowserView>
            {this.state.finished ? (
              <React.Fragment>
              <div style={{
                textAlign: 'center',
                alignItems: 'center'
              }}>
                {!this.state.showButtonEnd ? (
                  <img src={filesBaseUrl + 'story/fly-up.gif'} style={{height: '100vh', width: 'auto', bottom: 0}} alt="" />
                ) : (
                  <Grid container spacing={2}>
                    <Grid item xs={12} className="header">
                      <h1 style={{color: 'white'}}>Well Done!</h1>
                    </Grid>

                    <Grid container spacing={10} className="main">
                      <Grid item xs={6} className="main">
                        <div style={{float:'right'}}>
                        <LazyLoad><img src={filesBaseUrl + 'Badge.png'} style={{height: '20vh', width: 'auto'}} alt="" /></LazyLoad><br />
                        <h1 style={{color: 'white'}}>{`${this.state.score}`.split("").map((n, i) => (
                          <ReactTextTransition
                            key={i}
                            text={n}
                            delay={i * 100}
                            overflow
                            inline
                          />
                        ))} <br />
                        XP earned</h1>
                        </div>
                      </Grid>
                      <Grid item xs={6} className="main">
                        <div style={{float:'left', maxWidth: '50%'}}>
                          {this.state.similarityTestConducted ? (
                            <React.Fragment>
                            <h3 style={{color: 'white'}}>Your similarity score to Itay is</h3>
                            <CircularProgressbar value={this.state.similarityTestConductedScore} text={`${this.state.similarityTestConductedScore}%`} strokeWidth={3} styles={{
                              root: {width: '20vh'},
                              path: {
                                strokeLinecap: 'butt',
                                transition: 'stroke-dashoffset 0.5s ease 0s',
                                transform: 'rotate(0.25turn)',
                                transformOrigin: 'center center',
                              },
                              trail: {
                                stroke: '#d6d6d6',
                                strokeLinecap: 'butt',
                                transform: 'rotate(0.25turn)',
                                transformOrigin: 'center center',
                              },
                              text: {
                                fontSize: '2em',
                              },
                              background: {
                                fill: '#3e98c7',
                              },
                            }}/>
                            <h4 style={{color: 'white'}}>You are so similar that you should consider going to a space adventure together <span role="img" aria-label="spaceship">😋</span><span role="img" aria-label="spaceship">🚀</span></h4>
                            </React.Fragment>
                          ) : (
                            <React.Fragment>
                            {this.state.link === '' ? (
                              <React.Fragment>
                                <h3 style={{color: 'white'}}>Great Job!</h3>
                                <h4 style={{color: 'white'}}>You helped Astro to go back home!</h4>
                                <LazyLoad><img src={filesBaseUrl + 'head.png'} alt="astro"  style={{height: '20vh', width: 'auto'}} /></LazyLoad>
                              </React.Fragment>
                            ) : (
                              <React.Fragment>
                              <h3 style={{color: 'white'}}>Share your score on Facebook & find out how much your friends and family are differnt from you!</h3>
                              <div className="fb-share-button" data-href={this.state.link} data-layout="button" data-size="large">
                                <a target="_blank" rel="noopener noreferrer" href={"https://www.facebook.com/sharer/sharer.php?u="+this.state.link+"&src=sdkpreparse&quote=" + facebookAttachedContent}  className="fb-xfbml-parse-ignore">
                                  <LazyLoad><img src={filesBaseUrl + 'fb.png'} alt="Facebook" /></LazyLoad>
                                </a>
                              </div>
                              </React.Fragment>
                            )}
                            </React.Fragment>
                          )}
                        </div>
                      </Grid>
                    </Grid>

                    <Grid item xs={12} className="footer">
                      <br /><br /><br />
                      <img src={filesBaseUrl + 'story/Finish.gif'} style={{height: '20vh', width: 'auto', bottom: 0}} alt="" />
                    </Grid>
                  </Grid>
                )}
              </div>
              </React.Fragment>
            ) : (
              <React.Fragment>
              {this.state.started ? (
                <Grid container spacing={2}>
                  <Grid item xs={12} className="header">
                      <React.Fragment>
                      <div style={{float: 'left', marginTop: '2%', marginLeft: '2%'}}>
                        {this.pointsObject('desktop')}
                      </div>
                      <Divider style={{
                        color: 'transparent', backgroundColor: 'transparent', marginTop: '12vh'
                      }} />
                      <div>
                      <center>
                      <span style={{
                        color: 'white',
                        fontWeight: 'bold',
                      }}>
                        The spaceship is {Math.round((100 / this.state.levels) * (this.state.activeStepProp), 2)}% ready
                      </span>
                      <MobileStepper
                        variant="progress"
                        steps={this.state.levels + 1}
                        activeStep={this.state.activeStepProp}
                        style={{
                          backgroundColor: 'transparent',
                          minWidth: '197%',
                          textAlign: 'center',
                          alignItems: 'center'
                        }}
                        LinearProgressProps={{
                          style: {
                            color: '#1E8725'
                          }
                        }}
                        position="relative"
                      />
                      </center>
                      </div>
                      </React.Fragment>
                  </Grid>

                  <Grid container className="main">

                  {(this.state.betweenStages && this.state.activeStep !== this.state.levels + 1) && (
                    <div>
                      {this.subCharacter('desktop')}
                    </div>
                  )}

                  {this.state.nextLevelExists && this.state.questions[this.state.activeStep].QuestionType === multiChosing && this.state.chose === false && (this.state.activeStep < this.state.levels) && (
                    <React.Fragment>
                      <center style={{textAlign: 'center'}}>
                      <Grid item xs={12}>
                        <span className="title">
                          {multiChoiceCartText}
                        </span><br />
                        <div style={{maxWidth: '100%'}}>
                          {this.multiChosingButtons(this.state.questions[this.state.activeStep].Options, 'desktop')}
                        </div>

                        {this.state.selectedItems.length >= minimumChose && (
                          <center>
                          <Divider style={{backgroundColor: 'transparent', color: 'transparent', marginTop: '5%'}} />
                          <motion.div animate={{ scale: 1.7 }} transition={{ duration: 1 }} whileHover={{ scale: 1.1 }}
                          whileTap={{ scale: 0.9 }}>
                            <Button style={{
                              backgroundColor: '#F7F7F7',
                              color: '#1D133B',
                              fontWeight: 'bold',
                              borderRadius: '45px'
                            }}
                            onClick={(e) => this.multiChosingPressDone()}>Done!</Button>
                          </motion.div></center>
                        )}
                      </Grid>
                      </center>



                    </React.Fragment>
                  )}

                  {(this.state.nextLevelExists && this.state.questions[this.state.activeStep].QuestionType === multiChosingText[0] || this.state.questions[this.state.activeStep].QuestionType === multiChosingText[1]) && this.state.chose === false && (this.state.activeStep < this.state.levels) && (
                    <React.Fragment>
                      <center style={{textAlign: 'center'}}>
                      <Grid item xs={12}>
                        <span className="title">
                          {/*this.state.questions[this.state.activeStep].QuestionType === multiChosingText[0] ? multiChoiceText[0] : multiChoiceText[1]*/}
                          {this.state.questions[this.state.activeStep].QuestionText}
                        </span> <br />
                        {this.multiChosingTextButtons(this.state.questions[this.state.activeStep].Options, 'desktop')}
                        <Divider style={{color: 'transparent', backgroundColor: 'transparent', marginTop: '5%'}} />
                        {this.state.selectedItems.length >= minimumChose && (

                          <center>

                          <motion.div animate={{ scale: 1.7 }} transition={{ duration: 1 }} whileHover={{ scale: 1.1 }}
                          whileTap={{ scale: 0.9 }}>
                            <Button style={{
                              backgroundColor: '#F7F7F7',
                              color: '#1D133B',
                              fontWeight: 'bold',
                              borderRadius: '45px'
                            }}
                            onClick={(e) => this.multiChosingPressDone()}>Done!</Button>
                          </motion.div></center>
                        )}
                      </Grid>
                      </center>
                    </React.Fragment>
                  )}

                  {this.state.nextLevelExists && this.state.questions[this.state.activeStep].QuestionType === singleChosing && this.state.chose === false && (this.state.activeStep < this.state.levels) && (
                    <React.Fragment>
                      <center>
                      <Grid item xs={12}>
                        <div style={{maxWidth: '85%'}}>
                        <span className="title">
                          {this.diceTextModifier(this.state.questions[this.state.activeStep])}
                        </span><br />
                        </div>
                      </Grid>
                      </center>
                      <Grid item xs={12}>
                        <center>{this.singleChosingImage(diceImage, "desktop")}</center>
                      </Grid>
                      <Grid item xs={12}>
                        {this.singleChosingButtons(this.state.questions[this.state.activeStep].Options)}
                      </Grid>
                    </React.Fragment>
                  )}

                  {this.state.nextLevelExists && this.state.questions[this.state.activeStep].QuestionType === images && this.state.chose === false && (this.state.activeStep < this.state.levels) && (
                    <React.Fragment>
                      <Grid item xs={12}>
                        <span className="title">
                          {singleChoiceText}
                        </span>
                      </Grid>
                      <Grid container spacing={0}>
                        <Grid item xs={6}>{this.image(this.state.questions[this.state.activeStep].Images[0].url, 'left', 'desktop')}</Grid>
                        <Grid item xs={6}>{this.image(this.state.questions[this.state.activeStep].Images[1].url, 'right', 'desktop')}</Grid>
                      </Grid>
                    </React.Fragment>
                  )}


                  {this.state.finished && (
                    <Grid item xs={12}>
                      {this.state.finished && (
                        <img src={filesBaseUrl + 'story/fly-up.gif'} style={{maxHeight:'30vh', width: 'auto', bottom: '0'}} alt="" />
                      )}
                    </Grid>
                  )}

                  {!this.state.nextLevelExists && (
                    <Grid item xs={12}>
                      <center><motion.div animate={{ scale: 1.7 }} transition={{ duration: 1 }} whileHover={{ scale: 1.1 }}
                      whileTap={{ scale: 0.9 }}>
                        <Button style={{
                          backgroundColor: '#F7F7F7',
                          color: '#1D133B',
                          fontWeight: 'bold',
                          borderRadius: '45px'
                        }}
                        onClick={(e) => this.endGame()}>Let's fly!</Button>
                      </motion.div></center>
                    </Grid>
                  )}
                  </Grid>


                  <Grid item xs={12} className="footer">
                    {!this.state.nextLevelExists && (
                      <img src={filesBaseUrl + 'story/stage-8.gif'} style={{maxHeight:'30vh', width: 'auto', bottom: '0'}} alt="" />
                    )}
                    {this.state.activeStep < this.state.levels && (
                      <div>
                        {this.character('desktop')}
                      </div>
                    )}
                  </Grid>
                </Grid>
              ) : (
                <Grid container spacing={2}>
                  {this.state.preview ? (
                    <React.Fragment>
                    <Grid item xs={12} className="header">
                    </Grid>

                    <Grid item xs={12} className="main">
                      <center>
                        <div style={{
                          maxWidth: '75%'
                        }}>
                          <h1 style={{textAlign: 'center', color: 'white'}}>Help Astro to fix his Spaceship and return home! <span role="img" aria-label="spaceship">🚀</span></h1>
                          <h3 style={{textAlign: 'center', color: 'white'}}>Choose what best describe you, Try to set a record and help Astro rebuild his spaceship</h3>
                        </div><br />
                        <motion.div animate={{ scale: 1.7 }} transition={{ duration: 1 }} whileHover={{ scale: 1.1 }}
                        whileTap={{ scale: 0.9 }}>
                          <Button style={{
                            backgroundColor: '#F7F7F7',
                            color: '#1D133B',
                            fontWeight: 'bold',
                            borderRadius: '45px'
                          }}
                          onClick={(e) => this.start()}>START</Button>
                        </motion.div>
                      </center>
                    </Grid>

                    <Grid item xs={12} className="footer">
                      <img src={filesBaseUrl + "story/Start.gif"} style={{maxHeight: '30vh', width: 'auto', bottom: 0}} alt="" />
                    </Grid>
                    </React.Fragment>
                  ) : (
                    <React.Fragment>
                    <Grid item xs={12} className="header">
                      {this.state.showButtonStart && (
                        <center><motion.div animate={{ rotate: 360 }} transition={{ duration: 1 }}
                         style={{
                          maxWidth: '75%'
                        }}>
                          <h1 style={{textAlign: 'center', color: 'white'}}>Oh! No! Your Spaceship crashed into an asteroid!</h1>
                        </motion.div></center>
                      )}
                    </Grid>

                    <Grid item xs={12} className="main">
                      <img src={filesBaseUrl + "story/opening-Scene.gif"} style={{maxHeight: '50vh', width: 'auto'}} alt="" />
                    </Grid>

                    <Grid item xs={12} className="footer">
                      {this.state.showButtonStart && (
                        <center><motion.div animate={{ scale: 1.7 }} transition={{ duration: 1 }} whileHover={{ scale: 1.1 }}
                        whileTap={{ scale: 0.9 }}>
                          <Button style={{
                            backgroundColor: '#F7F7F7',
                            color: '#1D133B',
                            fontWeight: 'bold',
                            borderRadius: '45px'
                          }}
                          onClick={(e) => this.startGame()}>Are you ready?</Button>
                        </motion.div></center>
                      )}
                    </Grid>
                    </React.Fragment>
                  )}

                </Grid>
              )}
              </React.Fragment>
            )}


            </BrowserView>
          </div>
        ) : (
          <div>
            <h1 style={{color: 'white', alignItems: 'center', justifyContent: 'center'}}></h1>
          </div>
        )}
      </React.Fragment>

    );
  }
}

export default App;
